import { customOrange } from "core/theme/variants";

// Accento Mia Reputation: e' il colore del "neutralizzato" in tutti i grafici del resoconto.
export const MIA_ACCENT = "#734af3";

// Un colore per stato, sempre lo stesso fra ciambella, legenda e tile.
export const STATUS_COLORS: Record<string, string> = {
  removed: MIA_ACCENT,
  deindexed: "#a48bf7",
  removed_declared: "#d9cdfd",
  in_removal: customOrange[500],
  // neutro e distinto da "in rimozione", come nel PDF (render.STATUS_COLORS)
  unverifiable: "#9aa6c4",
  rejected: "#9e9e9e",
  // grigio chiaro, distinto da "in verifica manuale" e "respinti" (render.STATUS_COLORS)
  not_removed: "#c3c7cf",
};
